import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

const stored = localStorage.getItem("stukjes_token");
if (stored) api.defaults.headers.common["Authorization"] = `Bearer ${stored}`;

export function setToken(token) {
  if (token) {
    localStorage.setItem("stukjes_token", token);
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    localStorage.removeItem("stukjes_token");
    delete api.defaults.headers.common["Authorization"];
  }
}

export function formatApiError(detail) {
  if (detail == null) return "Une erreur est survenue. Réessayez.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Ordered fulfillment journey shown as a stepper to clients
export const STAGES = [
  { key: "en_attente", label: "Reçue", desc: "Demande reçue, en attente de traitement." },
  { key: "devis_envoye", label: "Devis proposé", desc: "Un devis détaillé vous a été proposé. Validez-le pour lancer la commande." },
  { key: "devis_valide", label: "Devis validé", desc: "Devis validé. Votre commande va être lancée." },
  { key: "en_preparation", label: "En préparation", desc: "Vos pièces sont en cours de préparation." },
  { key: "prete", label: "Prête à récupérer", desc: "Votre commande vous attend en magasin." },
  { key: "recuperee", label: "Récupérée", desc: "Commande remise. Merci !" },
];

export const STATUS_META = {
  en_attente: { label: "Reçue", color: "bg-blue-100 text-blue-700 border-blue-200" },
  devis_envoye: { label: "Devis proposé", color: "bg-amber-100 text-amber-700 border-amber-200" },
  devis_valide: { label: "Devis validé", color: "bg-sky-100 text-sky-700 border-sky-200" },
  en_preparation: { label: "En préparation", color: "bg-amber-100 text-amber-700 border-amber-200" },
  prete: { label: "Prête à récupérer", color: "bg-emerald-100 text-emerald-700 border-emerald-200" },
  recuperee: { label: "Récupérée", color: "bg-emerald-100 text-emerald-700 border-emerald-200" },
  // legacy
  termine: { label: "Récupérée", color: "bg-emerald-100 text-emerald-700 border-emerald-200" },
  annule: { label: "Annulée", color: "bg-rose-100 text-rose-700 border-rose-200" },
  annulee: { label: "Annulée", color: "bg-rose-100 text-rose-700 border-rose-200" },
};

// Phase colour: blue=reçue/envoyée, amber=traitement & calcul prix, emerald=validée, rose=annulée
export const PHASE = {
  en_attente: "blue",
  devis_envoye: "amber",
  devis_valide: "blue",
  en_preparation: "amber",
  prete: "emerald",
  recuperee: "emerald",
  annulee: "rose",
};

export function phaseOf(status) {
  return PHASE[normalizeStatus(status)] || "blue";
}

export function normalizeStatus(s) {
  if (s === "termine") return "recuperee";
  if (s === "annule") return "annulee";
  return s;
}

export function stageIndex(status) {
  const n = normalizeStatus(status);
  const i = STAGES.findIndex((st) => st.key === n);
  return i;
}

// Granular staff permissions (must mirror backend ALL_PERMISSIONS)
export const STAFF_PERMISSIONS = [
  { key: "analytics", label: "Tableau de bord", desc: "Voir les KPI et statistiques" },
  { key: "requests", label: "Demandes", desc: "Voir et prendre en charge les demandes" },
  { key: "quoting", label: "Devis", desc: "Préparer et envoyer les devis (prix)" },
  { key: "fulfillment", label: "Commandes", desc: "Faire avancer / annuler les commandes" },
  { key: "clients", label: "Clients", desc: "Accéder à la liste des clients" },
  { key: "priority", label: "Clients VIP", desc: "Gérer les clients prioritaires" },
];

export function hasPerm(user, perm) {
  if (!user) return false;
  if (user.role === "admin") return true;
  return (user.permissions || []).includes(perm);
}
